import React, { memo, useState, useEffect, useCallback } from 'react'
import { Form, DatePicker, Space } from 'antd'
import dayjs from 'dayjs'
import { changeDateToTimes } from '@/utils/tools'
import styles from '../../index.module.less'
import { FormatMap, LayoutEnum } from '../../enum'

const Index = (props: any) => {
  const { field, value, onChange } = props
  const { width, label, placeholder, layout, picker } = field
  const [inputValue, setInputValue] = useState('')

  // 将时间戳字符串转换为 moment 对象
  const momentValue = (value ? dayjs(Number(value)) : null) as any
  const format = FormatMap[picker]
  const handleInputValueChange = v => {
    const valueStr = changeDateToTimes(v)
    setInputValue(valueStr)
    onChange?.(valueStr)
  }

  return (
    <div className={styles.innerFieldWrap}>
      {layout === LayoutEnum.HORIZONTAL ? (
        <Space.Compact block>
          <div className={styles.addon}>{label}</div>
          <DatePicker
            picker={picker}
            format={format}
            value={momentValue}
            style={{ width }}
            // className='w-full'
            placeholder={placeholder || `请选择${label}`}
            onChange={handleInputValueChange}
          />
        </Space.Compact>
      ) : (
        <div className={styles.vertical}>
          <div className={styles.addon}>{label}</div>
          <DatePicker
            picker={picker}
            format={format}
            value={momentValue}
            style={{ width }}
            // className='w-full'
            placeholder={placeholder || `请选择${label}`}
            onChange={handleInputValueChange}
          />
        </div>
      )}
    </div>
  )
}

export default Index
